module.exports = __webpack_public_path__ + "static/media/uh.e97de3ed.PNG";